import { useCallback, useEffect } from "react";
import moment from "moment";
import { Box, useMediaQuery } from "@mui/material";
import { DateFilter, ReceiptList } from "../../../../Components/Molecules";
import { useCardData } from "../../../../Hooks";

export const CardExtractSection = ({
  cardLabel,
  cardLast4,
  embedded = false,
}) => {
  const matches = useMediaQuery("(min-width: 1220px)");
  const {
    state: cardData,
    handleGET: fetchCardDataGET,
    loading,
  } = useCardData();

  useEffect(() => {
    fetchCardDataGET({
      start_date: `${moment().startOf("month").format("YYYY-MM-DD")} 00:00:00`,
      end_date: `${moment().format("YYYY-MM-DD")} 23:59:59`,
    });
  }, []);

  const handleFilterSelection = useCallback(
    (value) => {
      fetchCardDataGET({
        start_date: value.start_date,
        end_date: value.end_date,
      });
    },
    [fetchCardDataGET]
  );

  const content = (
    <>
      {!embedded && (
        <div className="cartoes-section-header">
          <div>
            <h3>
              Extrato · {cardLabel} · Final {cardLast4}
            </h3>
            <p className="mt-0.5 text-xs font-normal text-gray-500">
              Lançamentos do cartão selecionado
            </p>
          </div>
        </div>
      )}

      {embedded && (
        <div className="cartoes-doc-panel__subhead">
          <p className="text-xs text-gray-500">
            {cardLabel} · Final {cardLast4}
          </p>
        </div>
      )}

      <Box
        px={embedded ? 0 : 2}
        pt={1.5}
        pb={0.5}
        sx={{ display: "flex", flexDirection: matches ? "row" : "column" }}
      >
        <DateFilter handleFilter={handleFilterSelection} />
      </Box>

      <ReceiptList
        hasFilter
        itens={cardData}
        loading={loading.GET}
        type="extract"
        title="Lançamentos"
      />
    </>
  );

  if (embedded) return <div className="cartoes-doc-panel__extract">{content}</div>;

  return <section className="app-card overflow-hidden">{content}</section>;
};
